export default "<i [attr.data-feather]=\"icon\"></i>";